/**
 * 협력 기관(연관 사이트) 캐러셀 기본값 — DB 비어 있을 때 폴백·관리 화면 초기값
 */
export const DEFAULT_RELATED_SITES = {
  title: '협력 기관',
  titleEn: 'Partner Organizations',
  interval: 3000,
  itemsPerView: 5,
  autoPlay: false,
  sites: [
    {
      image: '/assets/images/partners/gg.png',
      url: 'https://www.gg.go.kr/',
      name: '경기도청',
      nameEn: 'Gyeonggi Provincial Government'
    },
    {
      image: '/assets/images/partners/gbsa.png',
      url: 'https://sso.gbsa.or.kr/sso/gbsa/user/login/view',
      name: 'GBSA',
      nameEn: 'GBSA'
    },
    {
      image: '/assets/images/partners/yongin.svg',
      url: 'https://www.yongin.go.kr/index.do',
      name: '용인특례시',
      nameEn: 'Yongin Special City'
    },
    {
      image: '/assets/images/partners/hufs.png',
      url: 'https://www.hufs.ac.kr/sites/hufs/index.do',
      name: '한국외국어대학교',
      nameEn: 'Hankuk University of Foreign Studies'
    },
    {
      image: '/assets/images/partners/keti.png',
      url: 'https://www.keti.re.kr/main/main.php',
      name: '한국전자기술연구원',
      nameEn: 'Korea Electronics Technology Institute'
    },
    {
      image: '/assets/images/partners/naver-cloud.svg',
      url: 'https://www.ncloud.com/v2/',
      name: 'Naver Cloud',
      nameEn: 'Naver Cloud'
    }
  ]
};

export function normalizeRelatedSitesPayload(raw) {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_RELATED_SITES };
  const sites = Array.isArray(raw.sites) ? raw.sites : [];
  return {
    title: typeof raw.title === 'string' && raw.title.trim() ? raw.title : DEFAULT_RELATED_SITES.title,
    titleEn:
      typeof raw.titleEn === 'string' && raw.titleEn.trim() ? raw.titleEn : DEFAULT_RELATED_SITES.titleEn,
    interval: Number(raw.interval) > 0 ? Number(raw.interval) : DEFAULT_RELATED_SITES.interval,
    itemsPerView: Number(raw.itemsPerView) > 0 ? Number(raw.itemsPerView) : DEFAULT_RELATED_SITES.itemsPerView,
    autoPlay: raw.autoPlay === true,
    sites: sites.map((s) => ({
      image: s?.image != null ? String(s.image) : '',
      url: s?.url != null ? String(s.url) : '',
      name: s?.name != null ? String(s.name) : '',
      nameEn: s?.nameEn != null ? String(s.nameEn) : ''
    }))
  };
}
